module.exports = __webpack_public_path__ + "img/报刊视界.b91c08cc.png";